// ============================================================================
// หน้ารายละเอียดทรัพย์ — /room?project=<project_id>&uid=<listing_uid>
//
// เปิดสาธารณะ ไม่ต้อง login · project ไม่บังคับ (backend หาโครงการจากตัวห้องเองได้)
// ใช้ฟอนต์/สี/navbar/footer ชุดเดียวกับหน้าแรก (.mn-home / hm-*) เพื่อไม่ให้กด
// จากการ์ดแล้วเหมือนหลุดไปคนละเว็บ ส่วนเฉพาะของหน้านี้ใช้คลาส rm-* (room.css)
//
// โครงหน้า
//   แกลเลอรี (รูปเด่น + ตาราง 2x2 + ปุ่มดูทั้งหมด)
//   ซ้าย : หัวประกาศ+ราคา › รายละเอียด › จุดเด่น › ของใช้ในห้อง
//   ขวา : ติดต่อ/นัดชมทรัพย์ › ตารางข้อมูลทรัพย์ › ทำเลที่ตั้ง
//   ล่าง : ทรัพย์ใกล้เคียง (โครงการเดียวกัน)
//   มือถือ : แถบติดต่อติดขอบล่าง (โทร + สนใจทรัพย์นี้) เพราะกล่องติดต่อถูกดันไปอยู่ท้ายเนื้อหา
//
// ★ API สาธารณะไม่ส่งชื่อ/เบอร์เจ้าของห้องมาให้ ติดต่อผ่านนิติบุคคลเท่านั้น
// ★ ทุกบล็อกซ่อนตัวเองเมื่อไม่มีข้อมูล — ประกาศที่กรอกน้อยต้องไม่เหลือหัวข้อว่าง ๆ
// ============================================================================

import React, { Component } from "react";

import { loading } from "../components/loading.js";
import {
    fetchListingDetail,
    fetchListings,
    fetchPageContent,
    submitInquiry,
    getProjectIdFromUrl,
} from "../components/sale-api.js";
import { STATUS_COLOR, money, hasValue, lineUrl, telUrl, safeUrl, stripPrefixWord, thaiDate } from "../components/sale-format.js";

import HomeNavbar from "./home/components/HomeNavbar.js";
import HomeFooter from "./home/components/HomeFooter.js";
import HomeInquiry from "./home/components/HomeInquiry.js";
import HomePropertyCard from "./home/components/HomePropertyCard.js";
import HomeImage from "./home/components/HomeImage.js";
import ICON from "./home/icons.js";
import { stripJuristic } from "../components/text-sanitize.js";

import "../assets/css/homepage.css";
import "../assets/css/room.css";

// ไอคอนของสิ่งอำนวยความสะดวก — ชื่อที่ไม่รู้จักใช้ไอคอนติ๊กถูกแทน (ยังอ่านออกว่ามีของชิ้นนี้)
const FACILITY_ICON = {
    "เฟอร์นิเจอร์ครบ": ICON.home,
    "เครื่องปรับอากาศ": ICON.bolt,
    "เครื่องทำน้ำอุ่น": ICON.bath,
    "เครื่องซักผ้า": ICON.tag,
    "ตู้เย็น": ICON.building,
    "ทีวี": ICON.play,
    "อินเทอร์เน็ต": ICON.globe,
    "ที่จอดรถ": ICON.car,
    "ระเบียง": ICON.tree,
    "สระว่ายน้ำ": ICON.area,
    "ฟิตเนส": ICON.crown,
    "ลิฟต์": ICON.floor,
    "รปภ. 24 ชม.": ICON.shield,
    "กล้องวงจรปิด": ICON.camera,
    "เลี้ยงสัตว์ได้": ICON.paw,
};

const getUidFromUrl = () => new URLSearchParams(window.location.search).get("uid") || "";

// โหมดดูตัวอย่าง — เปิดจากหน้า "การตั้งค่าการขาย (โครงการ)" ฝั่งหลังบ้าน
// ★ ใช้ข้อมูลทดสอบชุดคงที่ ไม่ต้องมีห้องจริงที่เผยแพร่แล้ว
//   ผู้ดูแลจะได้ดูผลของสวิตช์เปิด/ปิดได้ทันทีตั้งแต่ก่อนมีประกาศใบแรก
const isPreviewMode = () => new URLSearchParams(window.location.search).get("preview") === "1";

// ข้อมูลทดสอบ — กรอกครบทุกช่องโดยตั้งใจ เพื่อให้ทุกบล็อก/ทุกสวิตช์มีของให้เห็น
const DEMO_LISTING = {
    uid: "preview",
    address_number: "101/99",
    project_name: "โครงการตัวอย่าง",
    property_type: "ห้องชุด",
    listing_type: "ขายและเช่า",
    price: 2500000,
    rent_price: 15000,
    rent_deposit: 30000,
    commission: 10000,
    rent_commission_method: "กำหนดรูปแบบค่าดำเนินการ",
    selling_status: "ว่าง",
    rent_status: "ว่าง",
    sell_with_tenant: false,

    building_no: "อาคาร A",
    building: "A",
    listing_floor: "ชั้น 7",
    floor: "7",
    usable_area: 39.5,
    room_size: 39.5,
    land_area: null,
    bedroom_count: 1,
    bathroom_count: 1,
    parking_count: 1,

    building_name: "ตัวอย่างคอนโด",
    address_moo: "",
    address_soi: "ตัวอย่าง 4",
    address_road: "พหลโยธิน",
    address_subdistrict: "ลาดยาว",
    address_district: "จตุจักร",
    address_province: "กรุงเทพมหานคร",
    address_postcode: "10900",
    map_url: "",

    highlight: "ใกล้รถไฟฟ้า, ห้องมุม, ตกแต่งครบพร้อมเข้าอยู่",
    facilities: ["เฟอร์นิเจอร์ครบ", "เครื่องปรับอากาศ", "อินเทอร์เน็ต", "ที่จอดรถ", "ฟิตเนส", "สระว่ายน้ำ", "รปภ. 24 ชม."],
    description:
        "ห้องตัวอย่างสำหรับดูหน้าตาเว็บก่อนเผยแพร่ประกาศจริง\nข้อมูลทั้งหมดในหน้านี้เป็นข้อมูลทดสอบ ไม่ใช่ห้องที่มีอยู่จริง\nใช้ตรวจว่าเปิด/ปิดบล็อกไหนไว้ แล้วหน้าเว็บจะออกมาหน้าตาแบบใด",
    images: [],
    cover_image: "",
    view_count: 128,
    announce_start_at: "2026-01-01 09:00",
    rent_end_at: null,
    project_id: "",
};

// ★ lineUrl / telUrl / money / STATUS_COLOR ย้ายไปอยู่ components/sale-format.js ใช้ร่วมกับหน้าแรก

export default class Room extends Component {
    state = {
        projectId: getProjectIdFromUrl(),
        uid: getUidFromUrl(),
        preview: isPreviewMode(),

        project: null,
        setting: {},
        // เนื้อหาหน้าเว็บของโครงการ (footer / social / faq) — ให้ฟุตเตอร์ครบเหมือนหน้าแรก
        content: {},
        // การตั้งค่าการขายของโครงการ — สวิตช์ว่าจะโชว์บล็อกไหน + ข้อมูลติดต่อ Admin
        // (ตั้งที่หน้า "การตั้งค่าการขาย (โครงการ)" ฝั่งหลังบ้าน)
        display: {},
        // ชื่อหัวข้อที่ผู้ดูแลแก้ (คีย์เดียวกับ display) — ไม่มี = ใช้ชื่อเริ่มต้นในโค้ด
        labels: {},
        adminContact: null,
        room: null,
        nearby: [],

        activeImage: 0,
        lightboxOpen: false,
        descriptionOpen: false,

        isLoading: true,
        errorMessage: "",

        inquiryOpen: false,
    };

    // ★ คีย์ที่ยังไม่เคยตั้งค่า = เปิด — ประกาศที่มีอยู่เดิมต้องแสดงครบเหมือนก่อนมีฟีเจอร์นี้
    show = (key) => this.state.display[key] !== false;

    // ชื่อหัวข้อ: ที่ผู้ดูแลแก้ไว้ ไม่งั้นใช้ค่าเริ่มต้น (ข้อความเดิมของหน้า)
    lb = (key, fallback) => {
        const value = this.state.labels[key];
        return typeof value === "string" && value.trim() ? value.trim() : fallback;
    };

    componentDidMount() {
        loading(false);
        window.scrollTo(0, 0);
        this.load();
    }

    componentDidUpdate(prevProps, prevState) {
        // lightbox เปิด = ฟังคีย์บอร์ดทั้งหน้า (Esc ปิด / ลูกศรเลื่อนรูป) · ปิด = คืนโฟกัสให้รูปที่กดเปิด
        if (!prevState.lightboxOpen && this.state.lightboxOpen) {
            document.addEventListener("keydown", this.onLightboxKey);
            if (this.lightboxCloseRef.current) this.lightboxCloseRef.current.focus();
        } else if (prevState.lightboxOpen && !this.state.lightboxOpen) {
            document.removeEventListener("keydown", this.onLightboxKey);
            if (this.lightboxReturnFocus && typeof this.lightboxReturnFocus.focus === "function") this.lightboxReturnFocus.focus();
        }
    }

    componentWillUnmount() {
        document.removeEventListener("keydown", this.onLightboxKey);
        this.unmounted = true;
    }

    lightboxCloseRef = React.createRef();

    load = async () => {
        const { projectId, uid, preview } = this.state;
        if (!uid && !preview) {
            this.setState({ isLoading: false, errorMessage: "ลิงก์ไม่สมบูรณ์ (ต้องมี &uid= ของห้อง)" });
            document.title = "ไม่พบห้องที่ต้องการ";
            return;
        }

        // ★ ไม่ดึง /projects แล้ว — หน้านี้ใช้แค่ในฟุตเตอร์ แต่ backend ต้อง query หลายรอบทุกครั้งที่เปิดห้อง
        //   (ฟอร์มนัดดูห้องในหน้านี้ผูกกับห้องเสมอ ไม่ต้องให้เลือกโครงการ)
        // ★ page-content ยิงครั้งเดียว : รู้โครงการจาก URL = ยิงคู่ขนานกับรายละเอียดห้อง
        //   ไม่รู้ (ลิงก์ไม่มี ?project=) = รอรายละเอียดห้องก่อนแล้วใช้โครงการของห้องนั้น
        //   เดิมยิงแบบไม่มีโครงการไปก่อน 1 รอบ (ได้โครงว่างของหน้ารวม) แล้วค่อยยิงซ้ำ
        let result = { ok: true, data: null };
        let contentRes = { ok: false };
        if (preview) {
            // โหมดตัวอย่างไม่ต้องยิงหาห้องจริง
            contentRes = await fetchPageContent(projectId);
        } else if (projectId) {
            [result, contentRes] = await Promise.all([fetchListingDetail(uid, projectId), fetchPageContent(projectId)]);
        } else {
            result = await fetchListingDetail(uid);
            const roomProjectId = result.ok ? result.data.project?.project_id : null;
            if (roomProjectId) contentRes = await fetchPageContent(roomProjectId);
        }
        if (this.unmounted) return;

        if (!preview && !result.ok) {
            this.setState({ isLoading: false, errorMessage: result.message || "ไม่พบห้องนี้" });
            document.title = "ไม่พบห้องที่ต้องการ";
            return;
        }

        // ★ โหมดตัวอย่างใช้ข้อมูลทดสอบ + ชื่อโครงการจริงจาก page-content
        const room = preview ? DEMO_LISTING : result.data.data;
        const project = preview ? contentRes.ok ? contentRes.data.project : null : result.data.project;
        const display = contentRes.ok ? contentRes.data.project_setting?.display || {} : {};

        this.setState(
            {
                project,
                room,
                // ภาพพื้นหลัง/โลโก้ชุดเดียวกับหน้าแรก กดเข้ามาแล้วจะได้ไม่รู้สึกเปลี่ยนเว็บ
                setting: contentRes.ok ? contentRes.data.setting || {} : {},
                content: contentRes.ok ? contentRes.data.data || {} : {},
                display,
                labels: contentRes.ok ? contentRes.data.project_setting?.labels || {} : {},
                adminContact: contentRes.ok ? contentRes.data.project_setting || null : null,
                isLoading: false,
            },
            this.loadNearby
        );
        this.setTitle(room, project, display);
    };

    // ชื่อแท็บ = ห้อง + โครงการ + ราคา (ตามสวิตช์ราคา) — แชร์/บุ๊กมาร์กแล้วรู้ว่าห้องไหน
    // ★ ค่าชุดเดียวกับที่ functions/room.js ใส่ให้ bot ของ LINE/Facebook (bot ไม่รัน JS)
    setTitle = (room, project, display) => {
        if (this.state.preview) {
            document.title = "ตัวอย่างหน้าประกาศ";
            return;
        }
        const show = (key) => display[key] !== false;
        const isRent = room.listing_type === "เช่า";
        const prices = [
            !isRent && show("price_sale") && hasValue(room.price) && `฿${money(room.price)}`,
            (isRent || room.listing_type === "ขายและเช่า") && show("price_rent") && hasValue(room.rent_price) && `เช่า ฿${money(room.rent_price)}/เดือน`,
        ].filter(Boolean);
        document.title = [
            `ห้อง ${room.address_number}`,
            stripJuristic(room.project_name || project?.project_name),
            prices.join(" · "),
        ]
            .filter(Boolean)
            .join(" · ");
    };

    go = (url) => {
        if (this.props.navigate) this.props.navigate(url);
        else window.location.href = url;
    };

    // ทรัพย์ใกล้เคียง = ห้องอื่นในโครงการเดียวกัน (ตัดห้องที่กำลังดูออก)
    loadNearby = async () => {
        const { room, preview } = this.state;
        if (preview) {
            // การ์ดทรัพย์ใกล้เคียงแบบทดสอบ ให้เห็นว่าบล็อกนี้เปิดอยู่ไหม
            this.setState({
                nearby: [1, 2, 3].map((i) => ({
                    ...DEMO_LISTING,
                    uid: `preview-${i}`,
                    address_number: `10${i}/0${i}`,
                    price: 2000000 + i * 250000,
                    rent_price: 12000 + i * 1000,
                })),
            });
            return;
        }

        const projectId = room?.project_id || this.state.projectId;
        if (!projectId) return;

        const result = await fetchListings({ project_id: projectId, page: 1, page_size: 8 });
        if (!result.ok || this.unmounted) return;

        const rows = (result.data.data || []).filter((item) => item.uid !== room.uid).slice(0, 4);
        this.setState({ nearby: rows });
    };

    backToList = () => {
        // มาจากหน้ารวมทุกโครงการ (ไม่มี project ใน URL) ก็กลับไปหน้ารวม
        const { projectId } = this.state;
        this.go(projectId ? `/overview?project=${encodeURIComponent(projectId)}` : "/overview");
    };

    openRoom = (item) => {
        const projectId = item.project_id || this.state.projectId;
        this.go(`/room?uid=${encodeURIComponent(item.uid)}${projectId ? `&project=${encodeURIComponent(projectId)}` : ""}`);
    };

    images = () => {
        const room = this.state.room;
        if (!room) return [];
        return room.images?.length ? room.images : room.cover_image ? [room.cover_image] : [];
    };

    moveLightbox = (step) =>
        this.setState((prev) => {
            const total = this.images().length;
            if (!total) return null;
            return { activeImage: (prev.activeImage + step + total) % total };
        });

    openLightbox = (index) => {
        this.lightboxReturnFocus = document.activeElement;
        this.setState({ activeImage: index, lightboxOpen: true });
    };

    closeLightbox = () => this.setState({ lightboxOpen: false });

    onLightboxKey = (event) => {
        if (event.key === "Escape") this.closeLightbox();
        else if (event.key === "ArrowLeft") this.moveLightbox(-1);
        else if (event.key === "ArrowRight") this.moveLightbox(1);
    };

    // ที่อยู่ของทรัพย์ 2 บรรทัด (บรรทัดแรก = เลขที่/ถนน/แขวง, บรรทัดสอง = เขต/จังหวัด/ไปรษณีย์)
    addressLines = () => {
        const r = this.state.room || {};
        const line1 = [
            r.address_number,
            r.building_name,
            r.address_moo ? `หมู่ ${r.address_moo}` : "",
            r.address_soi ? `ซ.${r.address_soi}` : "",
            r.address_road ? `ถ.${r.address_road}` : "",
            r.address_subdistrict ? `แขวง/ตำบล${r.address_subdistrict}` : "",
        ]
            .filter(Boolean)
            .join(" ");
        const line2 = [
            r.address_district ? `เขต/อำเภอ${r.address_district}` : "",
            r.address_province,
            r.address_postcode,
        ]
            .filter(Boolean)
            .join(" ");
        return [line1, line2].filter(Boolean);
    };

    // ลิงก์แผนที่ — ใช้ลิงก์ที่ผู้ประกาศใส่ไว้ก่อน ไม่มีก็ค้นจากที่อยู่
    // ★ map_url ผ่าน safeUrl — ผู้ประกาศกรอก "javascript:..." ได้ ถ้าใส่ href ตรง ๆ จะรันตอนกด
    //   ลิงก์ที่ไม่ผ่านถือว่าไม่มี แล้วใช้ลิงก์ค้นหาจากที่อยู่แทน
    mapLink = () => {
        const r = this.state.room || {};
        const custom = safeUrl(r.map_url);
        if (custom) return custom;
        const query = this.addressLines().join(" ") || stripJuristic(r.project_name) || "";
        return query ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}` : "";
    };

    // extraClass : rm-page--bar = มีแถบติดต่อติดขอบล่าง (มือถือ) ต้องเว้นที่ท้ายหน้าไม่ให้แถบบังฟุตเตอร์
    shell = (children, extraClass = "") => (
        <div className={`mn-home ${extraClass}`}>
            {/* ★ หน้ารายละเอียดไม่มี section ให้เลื่อน (ห้องประกาศ/โครงการ/ติดต่อ) จึงซ่อนเมนูชุดนั้น
                กดโลโก้ = กลับหน้ารวมของโครงการเดิม */}
            <HomeNavbar
                brand={this.state.setting.company_name_th || stripJuristic(this.state.project?.project_name)}
                logo={this.state.setting.logo_url}
                hideLinks
                onContact={() => this.setState({ inquiryOpen: true })}
            />
            {children}
            {/* ★ ฟุตเตอร์ส่งเนื้อหาครบเหมือนหน้าแรก (ข้อความ / โซเชียล / คำถาม) — เดิมส่งแค่ setting
                ไม่มีรายชื่อโครงการ เพราะหน้านี้ไม่ดึง /projects (ดู load) · คำถามลิงก์ไปบล็อกคำถามของหน้ารวม */}
            <HomeFooter
                content={(this.state.content.footer || [])[0]}
                setting={this.state.setting}
                socials={this.state.content.social || []}
                faqs={this.state.content.faq || []}
                faqHref={`/overview${this.state.projectId || this.state.room?.project_id ? `?project=${encodeURIComponent(this.state.projectId || this.state.room?.project_id)}` : ""}#hm-faq`}
            />
        </div>
    );

    // ---------------------------------------------------------------- ชิ้นส่วน

    card = (title, icon, body, extra) => (
        <section className="rm-card">
            {!!title && (
                <div className="rm-card__head">
                    <span className="hm-ico">{icon}</span>
                    {title}
                    {extra}
                </div>
            )}
            {body}
        </section>
    );

    spec = (icon, value, label) => (
        <div className="rm-spec" key={label}>
            <span className="hm-ico">{icon}</span>
            <span className="rm-spec__value">{value}</span>
            <span className="rm-spec__label">{label}</span>
        </div>
    );

    kv = (label, value) =>
        hasValue(value) ? (
            <div className="rm-kv" key={label}>
                <span className="rm-kv__k">{label}</span>
                <span className="rm-kv__v">{value}</span>
            </div>
        ) : null;

    renderGallery = (room, images) => {
        const isRent = room.listing_type === "เช่า";
        const showBoth = room.listing_type === "ขายและเช่า";
        const shown = images.slice(0, 5);
        const rest = images.length - shown.length;
        // ★ มือถือโชว์แค่ 3 ช่องแรก (room.css ซ่อน nth-child(n+4)) — "+N" ต้องอยู่ช่องสุดท้ายที่มองเห็น
        //   เดิมอยู่ช่องที่ 5 อย่างเดียว บนมือถือจึงไม่มีทางรู้ว่ามีรูปอีก
        const MOBILE_CELLS = 3;
        const restMobile = images.length - Math.min(images.length, MOBILE_CELLS);

        return (
            <div className="rm-gallery">
                {shown.map((image, index) => (
                    // ★ ปุ่มจริง (ไม่ใช่ div onClick) — Tab มาถึงและกด Enter/Space เปิดรูปได้
                    <button
                        type="button"
                        key={`${image}-${index}`}
                        className={`rm-gallery__cell ${index === 0 ? "rm-gallery__cell--main" : ""}`}
                        aria-label={`ดูรูปที่ ${index + 1} จาก ${images.length} แบบเต็มจอ`}
                        onClick={() => this.openLightbox(index)}
                    >
                        <HomeImage src={image} alt={`รูปที่ ${index + 1}`} icon={ICON.home} eager={index === 0} />
                        {index === 0 && (
                            <>
                                <div className="rm-gallery__badges">
                                    {!!room.selling_status && !isRent && (
                                        <span className={`hm-badge hm-badge--${STATUS_COLOR[room.selling_status] || "green"}`}>
                                            {room.selling_status}
                                        </span>
                                    )}
                                    {!!room.rent_status && (isRent || showBoth) && (
                                        <span className={`hm-badge hm-badge--${STATUS_COLOR[room.rent_status] || "green"}`}>
                                            เช่า: {room.rent_status}
                                        </span>
                                    )}
                                    {room.sell_with_tenant && <span className="hm-badge hm-badge--orange">ขายพร้อมผู้เช่า</span>}
                                </div>
                                <span className="rm-gallery__count">
                                    {`1 / ${images.length}`}
                                </span>
                            </>
                        )}
                        {/* ช่องสุดท้ายเมื่อรูปเกิน 5 ใบ — บอกจำนวนที่เหลือแทนการซ่อนเงียบ ๆ */}
                        {index === shown.length - 1 && rest > 0 && (
                            <span className="rm-gallery__more rm-gallery__more--desktop" aria-hidden="true">
                                +{rest}
                                <small>ดูทั้งหมด</small>
                            </span>
                        )}
                        {index === MOBILE_CELLS - 1 && restMobile > 0 && (
                            <span className="rm-gallery__more rm-gallery__more--mobile" aria-hidden="true">
                                +{restMobile}
                                <small>ดูทั้งหมด</small>
                            </span>
                        )}
                    </button>
                ))}
            </div>
        );
    };

    renderHeadCard = (room) => {
        const isRent = room.listing_type === "เช่า";
        const showBoth = room.listing_type === "ขายและเช่า";
        const place = this.addressLines()[0] || stripJuristic(room.project_name) || "";

        // ★ แต่ละช่องขึ้นเมื่อ "มีข้อมูล" และ "ผู้ดูแลเปิดสวิตช์ไว้" เท่านั้น
        const specs = [
            this.show("spec_bedroom") && hasValue(room.bedroom_count) && this.spec(ICON.bed, `${room.bedroom_count}`, this.lb("spec_bedroom", "ห้องนอน")),
            this.show("spec_bathroom") && hasValue(room.bathroom_count) && this.spec(ICON.bath, `${room.bathroom_count}`, this.lb("spec_bathroom", "ห้องน้ำ")),
            this.show("spec_area") &&
                hasValue(room.usable_area || room.room_size) &&
                this.spec(ICON.area, `${room.usable_area || room.room_size}`, this.lb("spec_area", "ตร.ม.")),
            this.show("spec_land") && hasValue(room.land_area) && this.spec(ICON.ruler, `${room.land_area}`, this.lb("spec_land", "ตร.ว.")),
            this.show("spec_floor") &&
                hasValue(room.listing_floor || room.floor) &&
                // ★ ค่าที่กรอกมามีคำว่า "ชั้น"/"อาคาร" นำหน้าอยู่แล้ว → ตัดออก ไม่งั้นได้ "ชั้น 5 ชั้น"
                this.spec(ICON.floor, stripPrefixWord(room.listing_floor || room.floor, "ชั้น"), this.lb("spec_floor", "ชั้น")),
            this.show("spec_building") &&
                hasValue(room.building_no || room.building) &&
                this.spec(ICON.building, stripPrefixWord(room.building_no || room.building, "อาคาร"), this.lb("spec_building", "อาคาร")),
            this.show("spec_parking") && hasValue(room.parking_count) && this.spec(ICON.car, `${room.parking_count}`, this.lb("spec_parking", "ที่จอดรถ")),
        ].filter(Boolean);

        return (
            <section className="rm-card">
                <div className="d-flex flex-wrap align-items-center gap-2">
                    <span className="rm-chip">ห้อง {room.address_number}</span>
                    {!!room.property_type && <span className="rm-chip rm-chip--ghost">{room.property_type}</span>}
                    <span className="rm-chip rm-chip--ghost">{room.listing_type}</span>
                </div>

                <h1 className="rm-title">{stripJuristic(room.project_name) || `ห้อง ${room.address_number}`}</h1>
                {!!place && (
                    <div className="rm-place">
                        <span className="hm-ico">{ICON.marker}</span>
                        {place}
                    </div>
                )}

                {!!specs.length && <div className="rm-specs">{specs}</div>}

                <div className="rm-price">
                    <div className="rm-price__row">
                        {(isRent || showBoth) && this.show("price_rent") && (
                            <span className={showBoth ? "rm-price__sub" : "rm-price__main"}>
                                {money(room.rent_price)} <small>บาท/เดือน</small>
                            </span>
                        )}
                        {!isRent && this.show("price_sale") && (
                            <span className="rm-price__main">
                                {money(room.price)} <small>บาท</small>
                            </span>
                        )}
                    </div>
                    {((hasValue(room.rent_deposit) && this.show("price_deposit")) || room.sell_with_tenant) && (
                        <div className="rm-price__note">
                            {hasValue(room.rent_deposit) && this.show("price_deposit") && (
                                <span>
                                    <span className="hm-ico">{ICON.shield}</span> {this.lb("price_deposit", "เงินประกัน")} {money(room.rent_deposit)} บาท
                                </span>
                            )}
                            {room.sell_with_tenant && (
                                <span>
                                    <span className="hm-ico">{ICON.key}</span> ขายพร้อมผู้เช่า
                                    {room.rent_end_at ? ` · สัญญาถึง ${thaiDate(room.rent_end_at)}` : ""}
                                </span>
                            )}
                        </div>
                    )}
                </div>
            </section>
        );
    };

    // ★ ช่องทางติดต่อ = "ข้อมูลติดต่อ Admin" ของประกาศนี้ (หน้าแก้ไขประกาศฝั่งผู้ดูแล)
    //   ประกาศไม่ได้กรอกสักช่อง = ใช้ข้อมูลติดต่อ Admin ของโครงการ (การตั้งค่าการขาย (โครงการ))
    //   ใช้ทั้งชุดจากที่เดียว ไม่ผสมรายช่อง — กันเบอร์คนหนึ่งไปคู่กับ LINE อีกคน
    // ★ ไม่มีทั้งคู่ = ไม่โชว์เบอร์/LINE/อีเมลเลย เหลือแค่ปุ่ม "สนใจทรัพย์นี้"
    //   (ไม่ fallback เป็นเบอร์โครงการ และไม่โชว์รายชื่อผู้ติดต่อ Admin กลางของทั้งระบบแล้ว)
    // แยกเป็นเมธอด เพราะกล่องติดต่อด้านขวากับแถบติดต่อบนมือถือต้องใช้ชุดเดียวกัน
    contactOf = (room) => {
        const CONTACT_KEYS = ["contact_name", "contact_phone", "contact_line", "contact_email"];
        const hasContact = (c) => !!c && CONTACT_KEYS.some((k) => !!c[k]);
        // ★ API ซ่อนช่องที่ปิดสวิตช์เป็น null แล้ว — ตัดสิน fallback จาก has_own_contact (ข้อมูลจริงก่อนซ่อน)
        //   ไม่งั้นประกาศที่กรอกแค่ LINE แล้วปิดสวิตช์ LINE จะหันไปโชว์ข้อมูลติดต่อของโครงการแทน
        //   API รุ่นเก่าที่ยังไม่มีฟิลด์นี้ = ใช้การตรวจแบบเดิม
        const ownContact = typeof room?.has_own_contact === "boolean" ? room.has_own_contact : hasContact(room);
        return ownContact ? room : hasContact(this.state.adminContact) ? this.state.adminContact : {};
    };

    renderSide = (room) => {
        const project = this.state.project;
        const addressLines = this.addressLines();
        const mapLink = this.mapLink();

        const contact = this.contactOf(room);
        const phone = contact.contact_phone || "";
        const line = lineUrl(contact.contact_line);

        return (
            <aside className="rm-col rm-side">
                {/* ---------------------------------------- ติดต่อ / นัดชมทรัพย์ */}
                {this.show("contact") &&
                    this.card(
                    this.lb("contact", "ติดต่อสอบถาม / นัดชมทรัพย์"),
                    ICON.headset,
                    <>
                        <div className="rm-contact__name">
                            {contact.contact_name || stripJuristic(project?.project_name) || "ผู้ดูแลโครงการ"}
                        </div>
                        <div className="rm-contact__sub mb-3">ติดต่อผ่านผู้ดูแลโครงการ</div>

                        {/* ★ ช่องทางติดต่อเป็นปุ่มกดได้ทั้ง 3 อัน (โทร / LINE / อีเมล) ข้อความบนปุ่มคือค่าจริง
                            คนเห็นเบอร์/ไอดีได้เลยโดยไม่ต้องกด และกดแล้วเปิดแอปที่ใช้ติดต่อทันที */}
                        {!!telUrl(phone) && this.show("contact_phone") && (
                            <a
                                className="hm-btn hm-btn--ghost w-100 mb-2"
                                href={telUrl(phone)}
                            >
                                <span className="hm-ico">{ICON.phone}</span> {phone}
                            </a>
                        )}

                        {!!line && this.show("contact_line") && (
                            <a
                                className="hm-btn hm-btn--ghost w-100 mb-2"
                                href={line}
                                target="_blank"
                                rel="noreferrer"
                            >
                                <span className="hm-ico">{ICON.comment}</span> {this.lb("contact_line", "LINE")} : {contact.contact_line}
                            </a>
                        )}

                        {!!contact.contact_email && this.show("contact_email") && (
                            <a className="hm-btn hm-btn--ghost w-100 mb-2" href={`mailto:${contact.contact_email}`}>
                                <span className="hm-ico">{ICON.mail}</span> {contact.contact_email}
                            </a>
                        )}

                        {this.show("contact_inquiry") && (
                            <button
                                type="button"
                                className="hm-btn hm-btn--primary w-100"
                                onClick={() => this.setState({ inquiryOpen: true })}
                            >
                                <span className="hm-ico">{ICON.calendar}</span> {this.lb("contact_inquiry", "สนใจทรัพย์นี้")}
                            </button>
                        )}
                        <div className="rm-contact__sub mt-2">
                            ติดต่อผ่านผู้ดูแลประกาศเท่านั้น ไม่ต้องโอนเงินมัดจำก่อนเข้าชมทรัพย์
                        </div>
                    </>
                )}

                {/* ---------------------------------------------- ข้อมูลทรัพย์ */}
                {this.show("property_info") &&
                    this.card(
                    this.lb("property_info", "ข้อมูลทรัพย์"),
                    ICON.file,
                    <div>
                        {[
                            this.show("info_property_type") && this.kv(this.lb("info_property_type", "ประเภททรัพย์"), room.property_type),
                            this.show("info_listing_type") && this.kv(this.lb("info_listing_type", "ประเภทประกาศ"), room.listing_type),
                            this.show("info_project") && this.kv(this.lb("info_project", "โครงการ"), stripJuristic(room.project_name)),
                            this.show("info_room_no") && this.kv(this.lb("info_room_no", "ห้องเลขที่"), room.address_number),
                            this.show("info_building") && this.kv(this.lb("info_building", "อาคาร"), stripPrefixWord(room.building_no || room.building, "อาคาร")),
                            this.show("info_floor") && this.kv(this.lb("info_floor", "ชั้น"), stripPrefixWord(room.listing_floor || room.floor, "ชั้น")),
                            this.show("info_area") &&
                                this.kv(
                                    this.lb("info_area", "พื้นที่ใช้สอย"),
                                    hasValue(room.usable_area || room.room_size)
                                        ? `${room.usable_area || room.room_size} ตร.ม.`
                                        : ""
                                ),
                            this.show("info_land") && this.kv(this.lb("info_land", "เนื้อที่ดิน"), hasValue(room.land_area) ? `${room.land_area} ตร.ว.` : ""),
                            this.show("info_bedroom") &&
                                this.kv(this.lb("info_bedroom", "ห้องนอน"), hasValue(room.bedroom_count) ? `${room.bedroom_count} ห้อง` : ""),
                            this.show("info_bathroom") &&
                                this.kv(this.lb("info_bathroom", "ห้องน้ำ"), hasValue(room.bathroom_count) ? `${room.bathroom_count} ห้อง` : ""),
                            this.show("info_parking") &&
                                this.kv(this.lb("info_parking", "ที่จอดรถ"), hasValue(room.parking_count) ? `${room.parking_count} คัน` : ""),
                            this.show("info_status") &&
                                this.kv(this.lb("info_status", "สถานะ"), room.listing_type === "เช่า" ? room.rent_status : room.selling_status),
                        ].filter(Boolean)}
                    </div>
                )}

                {/* ------------------------------------------------ ทำเลที่ตั้ง */}
                {this.show("location") &&
                    (!!addressLines.length || !!mapLink) &&
                    this.card(
                        this.lb("location", "ทำเลที่ตั้ง"),
                        ICON.map,
                        <>
                            <div className="rm-map mb-3">
                                <span className="hm-ico">{ICON.marker}</span>
                            </div>
                            {this.show("loc_address") && addressLines.map((line) => (
                                <div key={line} className="rm-contact__sub" style={{ fontSize: 13, color: "#55605a" }}>
                                    {line}
                                </div>
                            ))}
                            {!!mapLink && this.show("loc_map") && (
                                <a className="hm-btn hm-btn--ghost w-100 mt-3" href={mapLink} target="_blank" rel="noreferrer">
                                    <span className="hm-ico">{ICON.external}</span> {this.lb("loc_map", "ดูใน Google Maps")}
                                </a>
                            )}
                        </>
                    )}
            </aside>
        );
    };

    // ★ lightbox : role=dialog · Esc ปิด · ลูกศรซ้าย/ขวาเลื่อนรูป (ดู onLightboxKey)
    //   เปิดแล้วโฟกัสปุ่มปิด ปิดแล้วโฟกัสกลับไปที่รูปที่กดเปิด
    renderLightbox = (images) => {
        const { activeImage } = this.state;
        return (
            <div
                className="rm-lightbox"
                role="dialog"
                aria-modal="true"
                aria-label={`รูปภาพทรัพย์ ${activeImage + 1} จาก ${images.length}`}
                onClick={this.closeLightbox}
            >
                <button
                    type="button"
                    ref={this.lightboxCloseRef}
                    className="rm-lightbox__close hm-ico"
                    title="ปิด (Esc)"
                    aria-label="ปิด"
                    onClick={this.closeLightbox}
                >
                    {ICON.close}
                </button>
                <img src={images[activeImage]} alt={`รูปที่ ${activeImage + 1}`} onClick={(e) => e.stopPropagation()} />
                <div className="rm-lightbox__bar" onClick={(e) => e.stopPropagation()}>
                    <button type="button" className="rm-lightbox__nav hm-ico" aria-label="รูปก่อนหน้า" onClick={() => this.moveLightbox(-1)}>
                        {ICON.chevron_left}
                    </button>
                    <span aria-live="polite">
                        {activeImage + 1} / {images.length}
                    </span>
                    <button type="button" className="rm-lightbox__nav hm-ico" aria-label="รูปถัดไป" onClick={() => this.moveLightbox(1)}>
                        {ICON.chevron_right}
                    </button>
                </div>
            </div>
        );
    };

    // แถบติดต่อติดขอบล่างบนมือถือ — กล่องติดต่อด้านขวาถูกดันไปอยู่ท้ายเนื้อหาทั้งหมดบนจอเล็ก
    // คนที่อ่านรายละเอียดอยู่ต้องกดโทร/สนใจได้ทันทีโดยไม่ต้องเลื่อนหา · ซ่อนบนจอกว้างด้วย css
    renderMobileBar = (room) => {
        if (!this.show("contact")) return null;
        const phone = this.contactOf(room).contact_phone;
        const tel = this.show("contact_phone") ? telUrl(phone) : "";
        const inquiry = this.show("contact_inquiry");
        if (!tel && !inquiry) return null;
        return (
            <div className="rm-mobilebar" role="region" aria-label="ติดต่อเกี่ยวกับทรัพย์นี้">
                {!!tel && (
                    <a className="hm-btn hm-btn--ghost" href={tel} aria-label={`โทร ${phone}`}>
                        <span className="hm-ico">{ICON.phone}</span> {this.lb("contact_phone", "โทร")}
                    </a>
                )}
                {inquiry && (
                    <button type="button" className="hm-btn hm-btn--primary" onClick={() => this.setState({ inquiryOpen: true })}>
                        <span className="hm-ico">{ICON.calendar}</span> {this.lb("contact_inquiry", "สนใจทรัพย์นี้")}
                    </button>
                )}
            </div>
        );
    };

    render() {
        const s = this.state;

        if (s.isLoading) {
            return this.shell(
                <div className="hm-container py-5">
                    <div className="text-center py-5 hm-muted">กำลังโหลดข้อมูลห้อง...</div>
                </div>
            );
        }

        if (s.errorMessage || !s.room) {
            return this.shell(
                <div className="hm-container py-5">
                    <div className="hm-soon">
                        <span className="hm-soon__icon hm-ico">{ICON.info}</span>
                        <div className="hm-soon__title">ไม่พบห้องที่ต้องการ</div>
                        <div className="hm-soon__desc">{s.errorMessage || "ห้องนี้อาจถูกปิดประกาศไปแล้ว"}</div>
                        <button type="button" className="hm-btn hm-btn--primary hm-btn--sm mt-3" onClick={this.backToList}>
                            กลับไปหน้ารายการห้อง
                        </button>
                    </div>
                </div>
            );
        }

        const room = s.room;
        const images = this.images();
        const description = stripJuristic(room.description) || "";
        const isLongDescription = description.length > 320;
        const mobileBar = this.renderMobileBar(room);

        return this.shell(
            <>
                <div className="hm-container rm-wrap">
                    {/* ★ ต้องบอกให้ชัดว่านี่คือข้อมูลทดสอบ ไม่งั้นผู้ดูแลนึกว่าเป็นห้องจริงที่ขึ้นเว็บแล้ว */}
                    {s.preview && (
                        <div
                            className="rm-card mb-3"
                            data-testid="preview-banner"
                            style={{ background: "#fff6e5", borderColor: "#ffe0a3", color: "#8a5a00" }}
                        >
                            <b>ตัวอย่างหน้าประกาศ (ข้อมูลทดสอบ)</b>
                            <div className="text-14">
                                หน้านี้ใช้ข้อมูลสมมติเพื่อดูผลของการตั้งค่าเปิด/ปิดบล็อก ไม่ใช่ห้องที่มีอยู่จริง และไม่ได้เผยแพร่ต่อสาธารณะ
                            </div>
                        </div>
                    )}

                    {/* ------------------------------------------------ breadcrumb */}
                    <nav className="rm-crumb">
                        <button type="button" onClick={() => this.go("/overview")}>
                            หน้าแรก
                        </button>
                        <span className="hm-ico">{ICON.chevron_right_small}</span>
                        <button type="button" onClick={this.backToList}>
                            {room.listing_type}
                        </button>
                        {!!room.property_type && (
                            <>
                                <span className="hm-ico">{ICON.chevron_right_small}</span>
                                <span>{room.property_type}</span>
                            </>
                        )}
                        <span className="hm-ico">{ICON.chevron_right_small}</span>
                        <span className="rm-crumb__now">
                            {stripJuristic(room.project_name) || `ห้อง ${room.address_number}`}
                        </span>
                    </nav>

                    {/* ★ ไม่มีรูปเลย = ไม่แสดงกรอบแกลเลอรี (เดิมขึ้นกรอบใหญ่ว่าง ๆ มีแต่ไอคอนบ้าน ดูเหมือนหน้าพัง) */}
                    {this.show("gallery") && images.length > 0 && this.renderGallery(room, images)}

                    <div className="rm-layout">
                        <div className="rm-col">
                            {this.show("header") && this.renderHeadCard(room)}

                            {this.show("description") && !!description &&
                                this.card(
                                    this.lb("description", "รายละเอียด"),
                                    ICON.file,
                                    <>
                                        <p
                                            className="hm-muted mb-0"
                                            style={{
                                                lineHeight: 1.9,
                                                whiteSpace: "pre-line",
                                                ...(isLongDescription && !s.descriptionOpen
                                                    ? { maxHeight: 132, overflow: "hidden" }
                                                    : {}),
                                            }}
                                        >
                                            {description}
                                        </p>
                                        {isLongDescription && (
                                            <button
                                                type="button"
                                                className="hm-section__link mt-2"
                                                onClick={() => this.setState({ descriptionOpen: !s.descriptionOpen })}
                                            >
                                                {s.descriptionOpen ? "ย่อลง" : "ดูเพิ่มเติม"}{" "}
                                                <span className="hm-ico">
                                                    {s.descriptionOpen ? ICON.chevron_up : ICON.chevron_down}
                                                </span>
                                            </button>
                                        )}
                                    </>
                                )}

                            {this.show("highlight") && !!room.highlight &&
                                this.card(
                                    this.lb("highlight", "จุดเด่นของทรัพย์"),
                                    ICON.star,
                                    <div className="d-flex flex-wrap gap-2">
                                        {String(room.highlight)
                                            .split(/[,\n·]/)
                                            .map((i) => i.trim())
                                            .filter(Boolean)
                                            .map((item) => (
                                                <span key={item} className="rm-chip">
                                                    <span className="hm-ico">{ICON.check}</span>
                                                    {item}
                                                </span>
                                            ))}
                                    </div>
                                )}

                            {this.show("facilities") && !!room.facilities?.length &&
                                this.card(
                                    this.lb("facilities", "ของใช้ภายในห้อง"),
                                    ICON.home,
                                    <div className="rm-tiles">
                                        {room.facilities.map((item) => (
                                            <div key={item} className="rm-tile">
                                                <span className="hm-ico">{FACILITY_ICON[item] || ICON.check}</span>
                                                {item}
                                            </div>
                                        ))}
                                    </div>
                                )}

                            <div className="rm-meta">
                                <span>
                                    <span className="hm-ico">{ICON.eye}</span> เข้าชม {money(room.view_count)}
                                </span>
                                {!!room.announce_start_at && (
                                    <span>
                                        <span className="hm-ico">{ICON.calendar}</span> ลงประกาศ{" "}
                                        {thaiDate(room.announce_start_at)}
                                    </span>
                                )}
                                {/* วันสิ้นสุดประกาศ — ผู้สนใจรู้ว่าต้องติดต่อภายในเมื่อไร (DTO ส่งมานานแต่ไม่เคยแสดง) */}
                                {!!room.announce_end_at && (
                                    <span>
                                        <span className="hm-ico">{ICON.clock}</span> ประกาศถึง{" "}
                                        {thaiDate(room.announce_end_at)}
                                    </span>
                                )}
                                <span>
                                    <span className="hm-ico">{ICON.home}</span> ห้อง {room.address_number}
                                </span>
                            </div>
                        </div>

                        {this.renderSide(room)}
                    </div>
                </div>

                {/* ------------------------------------------------ ทรัพย์ใกล้เคียง */}
                {this.show("nearby") && !!s.nearby.length && (
                    <section className="hm-section">
                        <div className="hm-container">
                            <div className="hm-section__head">
                                <div>
                                    <h2 className="hm-section__title">{this.lb("nearby", "ทรัพย์ใกล้เคียง")}</h2>
                                    <p className="hm-section__desc">ห้องอื่นในโครงการเดียวกัน</p>
                                </div>
                                <button type="button" className="hm-section__link" onClick={this.backToList}>
                                    ดูทั้งหมด <span className="hm-ico">{ICON.chevron_right}</span>
                                </button>
                            </div>
                            <div className="hm-grid">
                                {s.nearby.map((item) => (
                                    <HomePropertyCard
                                        key={item.uid}
                                        item={item}
                                        onOpen={this.openRoom}
                                        onInquiry={() => this.setState({ inquiryOpen: true })}
                                    />
                                ))}
                            </div>
                        </div>
                    </section>
                )}

                {s.lightboxOpen && !!images.length && this.renderLightbox(images)}

                {mobileBar}

                {/* ★ preview : ข้อมูลสมมติ ส่งจริงไม่ได้ — HomeInquiry ปิดปุ่มส่งและบอกเหตุผล */}
                <HomeInquiry
                    open={s.inquiryOpen}
                    listing={room}
                    project={s.project}
                    preview={s.preview}
                    onClose={() => this.setState({ inquiryOpen: false })}
                    onSubmit={(payload) => submitInquiry(payload)}
                />
            </>,
            mobileBar ? "rm-page--bar" : ""
        );
    }
}
